import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { Typography, Box } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const Breadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    const getBreadcrumbName = (pathname, index, pathnames) => {
        const breadcrumbMap = {
            'product': 'Product',
            'pricing': 'Pricing',
            'connectors': 'Connectors',
            'integrations': 'Integrations',
            'company': 'Company',
            'login': 'Login',
            'register': 'Register',
            'terms': 'Terms of Service',
            'privacy': 'Privacy Policy',
            'legal': 'Legal',
            'data-deletion': 'Data deletion',
            'documentation': 'Documentation',
            'reporting': 'Reporting',
        };
        
        // Special handling for connector documentation pages
        if (pathname === 'documentation' && pathnames[index + 1]) {
            return 'Documentation';
        }
        
        // For connector ID (numeric), we'll show a generic "Connector" text
        if (pathname && !isNaN(pathname) && pathnames[index - 1] === 'documentation') {
            return 'Connector';
        }
        
        return breadcrumbMap[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);
    };

    if (pathnames.length === 0) return null;

    return (
        <Box
            className="dc-breadcrumb"
            display="flex"
            alignItems="center"
            role="navigation"
            aria-label="Breadcrumb"
        >
            <NavLink to="/" className="dc-breadcrumb__link">
                Home
            </NavLink>
            {pathnames.map((name, index) => {
                let routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;

                // Special handling for integrations path - redirect to connectors
                if (name === 'integrations') {
                    routeTo = '/connectors';
                }

                return (
                    <Box key={name} display="flex" alignItems="center">
                        <NavigateNextIcon className="dc-breadcrumb__sep" />
                        {isLast ? (
                            <Typography variant="body2" component="span" className="dc-breadcrumb__current">
                                {getBreadcrumbName(name, index, pathnames)}
                            </Typography>
                        ) : (
                            <NavLink to={routeTo} className="dc-breadcrumb__link">
                                {getBreadcrumbName(name, index, pathnames)}
                            </NavLink>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default Breadcrumb; 